import Vue from "vue";

Vue.filter('currencySign', (value) => {
    const currencies = {
        EUR : '&euro;',
        EURO : '&euro;',
        USD : '$',
        RUB : '₽'
    };
    return currencies[value]
})

Vue.filter('capitalize', (value) => {
    return value ? value.charAt(0).toUpperCase() + value.slice(1) : null
})

Vue.filter('uppercase', (value) => {
    return value.toUpperCase()
})

Vue.filter('priceFormat', (input, isCents = true, isRound = true, isRoundForamted = false) => {
    if(!input) return '0.00';

    if(isCents) {
        let intr = parseInt(input) / 100;
        input = intr.toString();
    }

    input = input.toString();

    const separation = " ";
    let before = input.split('.').length ? input.split('.')[0] : '';

    let after = '00';
    if(input.indexOf('.') > 0){
        after = input.split('.').length ? input.split('.')[input.split('.').length-1] : '';
        after = after.substring(0, 2);
        if(!after || before == after ) after = '00';
        if(after.length == 1) after = after + '0';
    }

    let result = before.split( /(?=(?:\d{3})+$)/ ).join( separation );

    result = isRound ? result : result + '.' + (isRoundForamted ? '<small>' + after + '</small>' : after) ;
    return result;
})

Vue.filter('wordEndings', (input, var1, var2, var3) => {
    input = parseInt(input) % 100;
    if (input>=11 && input<=19)  return var3;
    let i = input % 10;
    if(i ==  1) return var1;
    if(i > 0 && i < 5) return var2;
    return var3;
})